<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top">
      <div class="container">
        <div class="page-title">
          <router-link class="navbar-brand" to="/">
            <img src="../assets/images/logo.png" />
          </router-link>
          <div class="page-title-txt"></div>
        </div>
        <div class="collapse navbar-collapse" id="navbarScroll">
          <ul class="navbar-nav">
            <li class="nav-item" :class="{active: curPage==link.path}" v-for="link of links" :key="link.name">
              <router-link class="nav-link" :to="link.path" >{{link.name}}</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/intro" >活动介绍</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/news" >活动动态</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/works">作品展示</router-link>
            </li> -->
          </ul>
        </div>
        <div class="d-flex align-items-center">
          <a
            class="btn btn-outline-primary btn-round"
            data-toggle="modal"
            data-target="#modal-tip"
            @click="toLogin"
            v-show="!isLogin"
            >登录</a
          >
          <router-link class="btn btn-outline-primary btn-round" to="/myCenter" v-show="isLogin">个人中心</router-link>
          <!-- <a class="btn btn-outline-primary btn-round"
             href="/myCenter"><img src="../assets/images/logo.png" class="rounded-circle">个人中心</a> -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data(){
    return {
      hasLogin: false,
      links: [
        {name: '首页', path:'/home'},
        {name: '活动介绍', path:'/intro'},
        {name: '活动动态', path:'/news'},
        {name: '作品展示', path:'/works'},
      ],
      curPage: window.localStorage.getItem('headerName') || '/home'
    }
  },
  computed: {
    isLogin(){
      console.log("computed hasLogin");
      let token = window.localStorage.getItem('token')
      if (!token) {
        this.$store.commit('setToken', '')
      }else{
        this.$store.commit('setToken', token)
      }
      return this.$store.getters.hasLogin
      // let userInfo = window.localStorage.getItem('userInfo')
      // if (userInfo) {
      //   this.$store.commit('')
      // }
    }
  },
  watch: {
    $route(to, from) {
      // if (to.name == 'MyCenter') {
      //   return;
      // }
      this.curPage = to.path
      window.localStorage.setItem('headerName', to.path)
    }
  },
  methods: {
    toLogin(){
      this.$store.commit('setToken', '40o4wwk4csk0wsk08kg0kk4og8cc84ogg4owo084')
    }
  }
};
$(window).scroll(function() {
  if ($(window).scrollTop() > 80) {
    $(".navbar").addClass("bg-blur");
  } else {
    $(".navbar").removeClass("bg-blur");
  }
});
</script>


// WEBPACK FOOTER //
// src/components/header.vue